import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DynamicTable from "../../../components/DynamicTable";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import { fetchAllReviews } from "../../../services/Reviews";
import AppContainer from "./../../../components/AppContainer/index";
import { Typography } from "@mui/material";
import appcolors from "../../../constants/Colors";

const headerData = [
  "Apointment#_Id",
  "Date",
  "User Details",
  "Branch Name",
  "Reviews",
];

const tableRows = [
  "showApointmentId",
  "date_time",
  "client_user_details",
  "assingedBranch",
  "show_user_Reviews",
];

function UserReviews() {
  const [reviews, setReviews] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [searchInput, setSearchInput] = useState("");
  const [firlteredReviews, setFirlteredReviews] = useState([]);
  const { user } = useSelector((state) => state.user);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    if (selectedBranch?.length > 0) {
      handleFetchAllReviews();
    }
  }, [selectedBranch]);

  useEffect(() => {
    const filtered = reviews.filter((reviews) => {
      const nameMatch = reviews?.user?.name
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      const emailMatch = reviews?.user?.email
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      const ApointmentId = reviews?.appointmentID
        ?.toLowerCase()
        .includes(searchInput.toLowerCase());
      return nameMatch || emailMatch || ApointmentId;
    });
    setFirlteredReviews(filtered);
  }, [searchInput, reviews]);

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleFetchAllReviews = async () => {
    try {
      setIsLoading(true);
      const response = await fetchAllReviews({ branchId: selectedBranch });
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        let data = response?.data?.data;
        setReviews(data);
        setFirlteredReviews(data);
      } else {
        handleSnackbarVal(true, "error", response?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(true, "error", error?.data?.message);
      console.log(error, "errorerrorerrorerrorerror");
    }
  };

  const handleChangeSearchInput = (e) => {
    setSearchInput(e.target.value);
  };

  return (
    <AppContainer
      primaryHeading={"All Reviews"}
      secondaryHeading={"View, hide, and categories your reviews's reviews."}
      showSerach
      searchValue={searchInput}
      onChange={handleChangeSearchInput}
    >
      {firlteredReviews?.length > 0 ? (
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={firlteredReviews}
          showEdit
          showDetail
        />
      ) : (
        <Typography
          variant="h1"
          fontSize={23}
          textAlign={"center"}
          color={appcolors.black}
          mt={20}
          mb={20}
        >
          No Reviews Found!
        </Typography>
      )}
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
    </AppContainer>
  );
}

export default UserReviews;
